var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordingloader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 477,
    viewBox: "0 0 552 477",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 28C16 19.1635 23.1634 12 32 12H520C528.837 12 536 19.1634 536 28V440.734C536 449.57 528.837 456.734 520 456.734H32C23.1634 456.734 16 449.57 16 440.734V28Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709,
    filter: "url(#filter1_d_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 58C48 50.268 54.268 44 62 44H194C201.732 44 208 50.268 208 58V66C208 73.732 201.732 80 194 80H62C54.268 80 48 73.732 48 66V58Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709,
    filter: "url(#filter2_d_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404 58C404 50.268 410.268 44 418 44H490C497.732 44 504 50.268 504 58V66C504 73.732 497.732 80 490 80H418C410.268 80 404 73.732 404 66V58Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709,
    filter: "url(#filter3_dd_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 128C48 119.163 55.1634 112 64 112H488C496.837 112 504 119.163 504 128V192C504 200.837 496.837 208 488 208H64C55.1634 208 48 200.837 48 192V128Z",
    fill: "#FCFCFC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 112.5H488C496.56 112.5 503.5 119.44 503.5 128V192C503.5 200.56 496.56 207.5 488 207.5H64C55.4396 207.5 48.5 200.56 48.5 192V128C48.5 119.44 55.4396 112.5 64 112.5Z",
    stroke: "#D2D3D4",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 142C69 136.477 73.4772 132 79 132H115C120.523 132 125 136.477 125 142V178C125 183.523 120.523 188 115 188H79C73.4772 188 69 183.523 69 178V142Z",
    fill: "#3D63AF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.039 157.916L98.2009 155.127L93.3629 152.338C92.9731 152.118 92.5632 152.008 92.1634 152.008C90.9039 152.008 89.7544 153.018 89.7544 154.417V165.583C89.7544 166.992 90.9039 167.992 92.1634 167.992C92.5632 167.992 92.9731 167.892 93.3629 167.662L98.2009 164.873L103.039 162.084C104.648 161.154 104.648 158.835 103.039 157.916Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 139C141 135.134 144.134 132 148 132H358.367C362.233 132 365.367 135.134 365.367 139C365.367 142.866 362.233 146 358.367 146H148C144.134 146 141 142.866 141 139Z",
    fill: "#E3E4E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 162C141 158.686 143.686 156 147 156H274.633C277.947 156 280.633 158.686 280.633 162C280.633 165.314 277.947 168 274.633 168H147C143.686 168 141 165.314 141 162Z",
    fill: "#E3E4E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 183C141 180.239 143.239 178 146 178H232.719C235.48 178 237.719 180.239 237.719 183C237.719 185.761 235.48 188 232.719 188H146C143.239 188 141 185.761 141 183Z",
    fill: "#E3E4E5"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709,
    filter: "url(#filter4_dd_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6284 239.535C54.6284 230.955 61.5836 224 70.1633 224H481.836C490.416 224 497.371 230.955 497.371 239.535V301.674C497.371 310.254 490.416 317.209 481.836 317.209H70.1632C61.5836 317.209 54.6284 310.254 54.6284 301.674V239.535Z",
    fill: "#FCFCFC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1636 224.485H481.836C490.148 224.485 496.886 231.224 496.886 239.535V301.674C496.886 309.985 490.148 316.724 481.836 316.724H70.1636C61.852 316.724 55.1138 309.985 55.1138 301.674V239.535C55.1138 231.224 61.852 224.485 70.1636 224.485Z",
    stroke: "#D2D3D4",
    strokeWidth: 0.970927,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0181 253.128C75.0181 247.765 79.3651 243.418 84.7273 243.418H119.681C125.043 243.418 129.39 247.765 129.39 253.128V288.081C129.39 293.443 125.043 297.79 119.681 297.79H84.7273C79.3651 297.79 75.0181 293.443 75.0181 288.081V253.128Z",
    fill: "#3D63AF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.067 268.581L103.37 265.873L98.6725 263.165C98.294 262.952 97.8961 262.845 97.5079 262.845C96.285 262.845 95.1689 263.825 95.1689 265.184V276.025C95.1689 277.393 96.285 278.364 97.5079 278.364C97.8961 278.364 98.294 278.267 98.6725 278.044L103.37 275.336L108.067 272.628C109.63 271.726 109.63 269.474 108.067 268.581Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.925 250.215C144.925 246.461 147.968 243.418 151.721 243.418H355.973C359.726 243.418 362.769 246.461 362.769 250.215C362.769 253.969 359.726 257.011 355.973 257.011H151.721C147.968 257.011 144.925 253.969 144.925 250.215Z",
    fill: "#E3E4E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.925 272.546C144.925 269.329 147.533 266.721 150.75 266.721H274.673C277.89 266.721 280.498 269.329 280.498 272.546C280.498 275.764 277.89 278.372 274.673 278.372H150.75C147.533 278.372 144.925 275.764 144.925 272.546Z",
    fill: "#E3E4E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.925 292.936C144.925 290.255 147.098 288.081 149.779 288.081H233.977C236.658 288.081 238.832 290.255 238.832 292.936C238.832 295.617 236.658 297.791 233.977 297.791H149.779C147.098 297.791 144.925 295.617 144.925 292.936Z",
    fill: "#E3E4E5"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709,
    filter: "url(#filter5_dd_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6284 348.463C58.6284 340.038 65.4579 333.209 73.8826 333.209H478.117C486.542 333.209 493.371 340.038 493.371 348.463V409.48C493.371 417.904 486.542 424.734 478.117 424.734H73.8825C65.4579 424.734 58.6284 417.904 58.6284 409.48V348.463Z",
    fill: "#FCFCFC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8823 333.686H478.118C486.279 333.686 492.895 340.302 492.895 348.463V409.479C492.895 417.641 486.278 424.257 478.117 424.257H73.8823C65.7211 424.257 59.105 417.641 59.105 409.479V348.463C59.1051 340.302 65.7211 333.686 73.8823 333.686Z",
    stroke: "#D2D3D4",
    strokeWidth: 0.953383,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6494 361.81C78.6494 356.545 82.9179 352.277 88.1832 352.277H122.505C127.77 352.277 132.039 356.545 132.039 361.81V396.132C132.039 401.398 127.77 405.666 122.505 405.666H88.1832C82.9178 405.666 78.6494 401.398 78.6494 396.132V361.81Z",
    fill: "#3D63AF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4850_28216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.101 376.984L106.489 374.326L101.876 371.667C101.505 371.457 101.114 371.352 100.733 371.352C99.532 371.352 98.436 372.315 98.436 373.649V384.294C98.436 385.638 99.532 386.591 100.733 386.591C101.114 386.591 101.505 386.495 101.876 386.276L106.489 383.617L111.101 380.958C112.636 380.072 112.636 377.861 111.101 376.984Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.293 358.95C147.293 355.265 150.281 352.277 153.967 352.277H354.527C358.213 352.277 361.201 355.265 361.201 358.95C361.201 362.636 358.213 365.624 354.527 365.624H153.967C150.281 365.624 147.293 362.636 147.293 358.95Z",
    fill: "#E3E4E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.293 380.878C147.293 377.719 149.854 375.158 153.013 375.158H274.696C277.856 375.158 280.417 377.719 280.417 380.878C280.417 384.037 277.856 386.598 274.696 386.598H153.013C149.854 386.598 147.293 384.037 147.293 380.878Z",
    fill: "#E3E4E5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.980709
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.293 400.899C147.293 398.266 149.427 396.132 152.06 396.132H234.736C237.369 396.132 239.503 398.266 239.503 400.899C239.503 403.532 237.369 405.666 234.736 405.666H152.06C149.427 405.666 147.293 403.532 147.293 400.899Z",
    fill: "#E3E4E5"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4850_28216",
    x: 0,
    y: 0,
    width: 552,
    height: 476.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_28216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4850_28216",
    x: 40,
    y: 38,
    width: 176,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_28216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4850_28216",
    x: 396,
    y: 38,
    width: 116,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4850_28216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_4850_28216",
    x: 24,
    y: 96,
    width: 504,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4850_28216",
    result: "effect2_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4850_28216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_4850_28216",
    x: 31.3262,
    y: 208.465,
    width: 489.347,
    height: 139.813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.94185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.91278
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.76742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6511
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4850_28216",
    result: "effect2_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4850_28216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_4850_28216",
    x: 35.7472,
    y: 317.955,
    width: 480.505,
    height: 137.287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.90677
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.86015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.62707
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4406
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4850_28216",
    result: "effect2_dropShadow_4850_28216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4850_28216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4850_28216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(85 148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4850_28216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3023,
    height: 23.3023,
    fill: "white",
    transform: "translate(90.5527 258.953)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4850_28216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.8812,
    height: 22.8812,
    fill: "white",
    transform: "translate(93.9033 367.531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingloader);
export default __webpack_public_path__ + "static/media/recordingloader.27a4d7ea8d6da472772a42baec99303e.svg";
export { ForwardRef as ReactComponent };